import { Text, Box, Divider } from "@chakra-ui/react";
import { capitalize } from "lodash";
import React from "react";

export function DetailsDisplay({ details }: { details: { [key: string]: string | undefined } }) {
  return (
    <>
      {details ? (
        <>
          <Box
            display="grid"
            gridTemplateColumns="auto 1fr"
            alignItems="center"
            minHeight="fit-content"
            minWidth="fit-content"
            border="1px solid"
            borderColor="gray.200"
            borderRadius="md"
            overflow="hidden"
          >
            {Object.entries(details).map(([key, value]) => {
              const capitalizeAllWords = key
                .split(" ")
                .map(word => capitalize(word))
                .join(" ");

              return (
                <React.Fragment key={key}>
                  <Text
                    className="key"
                    fontSize={18}
                    fontWeight={"bold"}
                    whiteSpace="nowrap"
                    py={1}
                    px={3}
                    borderBottom="1px solid"
                    borderRight="1px solid"
                    borderColor="gray.200"
                    bg="gray.50"
                    height="100%"
                    display="flex"
                    alignItems="center"
                  >
                    {capitalizeAllWords}
                  </Text>
                  <Text fontSize={18} py={1} px={3} borderBottom="1px solid" borderColor="gray.200">
                    {value ?? "-"}
                  </Text>
                </React.Fragment>
              );
            })}
          </Box>
          <Divider my={4} />
        </>
      ) : (
        <Text>No Details</Text>
      )}
    </>
  );
}
